import React from 'react';
import PropTypes from 'prop-types';
import Stack from 'react-bootstrap/Stack';
import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';
import i18next from '../../translations/i18n';
import './index.scss';

const EmptyResult = ({ checkedFilters = '', message }) => (
  <Container className="empty_result">
    <Stack className="d-flex shadow-lg justify-center d-flex p-5 m-5 ">
      <span className="empty_result__icon" />
      <Card.Text className="align-self-center">
        <Card.Title className="d-inline"> {message}</Card.Title>
        {checkedFilters.split(', ').map((filter, index) => (
          <strong className="post__error-text" key={i18next.t(filter)}>
            {index > 0 ? ',' : ''} {i18next.t(filter)}
          </strong>
        ))}
      </Card.Text>
    </Stack>
  </Container>

);
EmptyResult.defaultProps = {
  checkedFilters: '',
  message: '',
};
EmptyResult.propTypes = {
  checkedFilters: PropTypes.string,
  message: PropTypes.string,
};
export default EmptyResult;
